import { Box, Grid, Tab, Tabs, useMediaQuery, useTheme } from "@mui/material";
import { useAccess } from "@platformx/utilities";
import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NOTIFICATION_PERMISSION } from "../../../../utils/Constants";
import { contentStatusTitleSubTitles, notificationTitleSubTitles } from "../../../../utils/Helper";
import AuthorToggle from "../AdditionalSettings/AuthorToggle";
import Analytics from "../Analytics/Analytics";
import ContentStatus from "../ContentStatus/ContentStatus";
import NotificationSetting from "../NotificationSetting/NotificationSetting";
import Seo from "../Seo/Seo";
import SocialShare from "../SocialShare/SocialShare";
import { useStyles } from "./VerticalTabsArticle.styles";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function VerticalTabsArticle({
  state,
  setState,
  socialOgTags,
  setSocialOgTags,
  updateStructureDataArticle,
  slugField,
}) {
  const [value, setValue] = useState(0);
  const classes = useStyles(value);

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  const { t } = useTranslation();
  const theme = useTheme();
  const ifTab = useMediaQuery(theme.breakpoints.up("sm"));
  const { canAccessAction } = useAccess();
  /* Notification settings are driven by the logged-in user's session permissions */
  const hasNotificationAccess = canAccessAction(
    NOTIFICATION_PERMISSION.category,
    NOTIFICATION_PERMISSION.subCategory,
    NOTIFICATION_PERMISSION.action,
  );

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} md={3.1} className={classes.tabsContainer}>
        <Tabs
          orientation={ifTab ? "vertical" : "horizontal"}
          value={value}
          onChange={handleChange}
          className={classes.tabsProps}
          TabIndicatorProps={{
            style: { display: "none" },
          }}>
          <Tab
            value={0}
            className={classes.tabProps}
            sx={{
              textTransform: "capitalize",
              fontWeight: value === 0 ? 600 : 400,
              textAlign: "left",
              alignItems: "flex-start",
            }}
            label={t("page_social_share")}
          />
          <Tab
            value={1}
            className={classes.tabProps}
            sx={{
              textTransform: "capitalize",
              fontWeight: value === 1 ? 600 : 400,
              textAlign: "left",
              alignItems: "flex-start",
            }}
            label={t("page_prelem_seo")}
          />
          <Tab
            value={2}
            className={classes.tabProps}
            sx={{
              textTransform: "capitalize",
              fontWeight: value === 2 ? 600 : 400,
              textAlign: "left",
              alignItems: "flex-start",
            }}
            label={t("analytics")}
          />
          {hasNotificationAccess ? (
            <Tab
              value={3}
              className={classes.tabProps}
              sx={{
                textTransform: "capitalize",
                fontWeight: value === 3 ? 600 : 400,
                textAlign: "left",
                alignItems: "flex-start",
              }}
              label={t("notification")}
            />
          ) : null}
          <Tab
            value={4}
            className={classes.tabProps}
            sx={{
              textTransform: "capitalize",
              fontWeight: value === 4 ? 600 : 400,
              textAlign: "left",
              alignItems: "flex-start",
            }}
            label={t("content status")}
          />
          <Tab
            value={5}
            className={classes.tabProps}
            sx={{
              textTransform: "capitalize",
              fontWeight: value === 5 ? 600 : 400,
              textAlign: "left",
              alignItems: "flex-start",
            }}
            label={t("additional_settings")}
          />
        </Tabs>
      </Grid>
      <Grid item xs={12} md={8.9}>
        <TabPanel value={value} index={0}>
          <SocialShare
            state={state}
            setState={setState}
            socialOgTags={socialOgTags}
            setSocialOgTags={setSocialOgTags}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Seo
            state={state}
            setState={setState}
            updateStructureDataArticle={updateStructureDataArticle}
            slugField={slugField}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Analytics state={state} setState={setState} />
        </TabPanel>
        {hasNotificationAccess ? (
          <TabPanel value={value} index={3}>
            <NotificationSetting
              state={state}
              setState={setState}
              titleSubTitles={notificationTitleSubTitles()}
            />
          </TabPanel>
        ) : null}
        <TabPanel value={value} index={4}>
          <ContentStatus
            state={state}
            setState={setState}
            titleSubTitles={contentStatusTitleSubTitles()}
          />
        </TabPanel>
        <TabPanel value={value} index={5}>
          <AuthorToggle state={state} setState={setState} />
        </TabPanel>
      </Grid>
    </Grid>
  );
}

VerticalTabsArticle.propTypes = {
  state: PropTypes.object.isRequired,
  setState: PropTypes.func.isRequired,
  socialOgTags: PropTypes.object,
  setSocialOgTags: PropTypes.func,
  updateStructureDataArticle: PropTypes.func.isRequired,
  slugField: PropTypes.object,
};
